/**
 * מעבר בין עמודים — TASKS 6.2 · DESIGN.md 6.5.
 *
 * ⭐ יציאה: `opacity 1->0`, 120ms · כניסה: `opacity 0->1, y 8->0`, 200ms,
 *    ease `[0.16,1,0.3,1]`. `reduced-motion`: fade בלבד (בלי y), 100ms —
 *    "המצב עדיין מתקשר 'עמוד חדש' בלי תזוזה".
 * ⭐ `key={location.pathname}` על הרכיב הזה (ב-`PublicShell.tsx`) הוא מה
 *    שמפעיל את `AnimatePresence` — ⛔ לא הרכיב עצמו קובע מתי הוא מתחלף.
 */
import { motion, useReducedMotionConfig } from 'motion/react';
import type { ReactNode } from 'react';

const EASE = [0.16, 1, 0.3, 1] as const;

const VARIANTS = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2, ease: EASE } },
  exit: { opacity: 0, y: 0, transition: { duration: 0.12, ease: 'easeIn' } },
};

const REDUCED_VARIANTS = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.1 } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};

export function PageTransition({ children }: { children: ReactNode }) {
  const reducedMotion = useReducedMotionConfig();

  return (
    <motion.div
      data-testid="page-transition"
      variants={reducedMotion ? REDUCED_VARIANTS : VARIANTS}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      {children}
    </motion.div>
  );
}
